
export class Pais {
    id: string;
    descripcion: string;
    codigo: number;
    habilitacion:boolean;
}
